import React, { useEffect } from "react";
import { Col, Container, Row, FormGroup, Card,Tabs,Tab} from "react-bootstrap";
import { Input, Form, Checkbox, Select} from 'antd';
import { AuthHeader, ImageElement } from "../../components";
import { Link } from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";

function Payonline() {
    useEffect(() => {
        let navbar = document.querySelector(".header");
        let navbarHeight = navbar?.clientHeight;
        let payPage = document.querySelector(".payPage_inner");
        if(payPage){
            payPage.style.minHeight = `${window.innerHeight - navbarHeight}px`;
        }
    });
    return (
        <>
            <AuthHeader/>
            <main className="payPage">
                <div className="payPage_inner d-flex flex-column justify-content-center align-items-center ">  
                    <Container>                    
                        <Row className="justify-content-center">
                            <Col lg={6} md={8}>
                                <div className="bg-white br-10">
                                    <div className="commonTabs">
                                        <Tabs
                                            defaultActiveKey="Sign-In"
                                            transition={false}
                                            id="noanim-tab-example"
                                            className="mb-3"
                                            >
                                            <Tab eventKey="Sign-In" title="Sign In">                           
                                                <div className="payPage_sign">
                                                    <div className="payPage_sign_txt d-flex justify-content-between align-items-center">
                                                        <h2>Already Account?</h2>
                                                        <Link to='/' className="btn btn-info btn-sm d-inline-flex" type="button">Login</Link>
                                                    </div>                                                    
                                                    <p className="text-center payPage_sign_or">OR</p>
                                                    <div className="text-center">
                                                        <Link to='/' className="btn btn-primary d-inline-flex" type="button"> Check Out As Guest</Link>
                                                    </div>
                                                    <p className="payPage_sign_para">Signing up allows you to schedule appointments, cancel appointments, view past receipts, pay online (contactless payments), view/approve quotes, track your technician on the way to your home, take advantage of any specials, and more.</p>
                                                </div>
                                            </Tab>
                                            <Tab eventKey="Check-Out-As-Guest" title="Check Out As Guest">                       
                                                <Form>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Job Number</label>
                                                                <Input size="large" type="number" placeholder="Enter Job Number" value="39410802"/>
                                                            </FormGroup>
                                                        </Col>    
                                                        <Col lg={12}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Service Address</label>
                                                                <TextArea size="large" placeholder="Enter Service Address" value="Suyash Hospital, AB Road, opposite MGM Medical College, South Tukoganj, Indore, Madhya Pradesh, India 452001 282001"/>
                                                            </FormGroup>
                                                        </Col>    
                                                        <Col lg={6}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Total Amount</label>
                                                                <Input size="large" type="number" placeholder="Enter Total Amount" value="5196.09"/>
                                                            </FormGroup>
                                                        </Col>    
                                                        <Col lg={6}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Remaining Amount</label>
                                                                <Input size="large" type="number" placeholder="Enter Remaining Amount" value="5196.09"/>
                                                            </FormGroup>
                                                        </Col>    
                                                        <Col lg={12}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Card Holder</label>
                                                                <Input size="large" placeholder="Enter Card Holder"/>
                                                            </FormGroup>
                                                        </Col>    
                                                        <Col lg={12}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Card Number</label>
                                                                <Input size="large" type="number" placeholder="Enter Your Card Number"/>
                                                            </FormGroup>
                                                        </Col>  
                                                        <Col lg={6}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Exp. Month</label>
                                                                    <Select size="large" className="w-100" placeholder="Select Month"
                                                                        options={[
                                                                            {
                                                                                value: '1',
                                                                                label: '01',
                                                                            },
                                                                            {
                                                                                value: '2',
                                                                                label: '02',
                                                                            },
                                                                            {
                                                                                value: '3',
                                                                                label: '03',
                                                                            },
                                                                            {
                                                                                value: '4',
                                                                                label: '04',
                                                                            },
                                                                            {
                                                                                value: '5',
                                                                                label: '05',
                                                                            },
                                                                            {
                                                                                value: '6',
                                                                                label: '06',
                                                                            },
                                                                        ]}
                                                                    />
                                                            </FormGroup>
                                                        </Col>  
                                                        <Col lg={6}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Exp. Year</label>
                                                                    <Select size="large" className="w-100" placeholder="Select Year"
                                                                        options={[
                                                                            {
                                                                                value: '1',
                                                                                label: '2023',
                                                                            },
                                                                            {
                                                                                value: '2',
                                                                                label: '2024',
                                                                            },
                                                                            {
                                                                                value: '3',
                                                                                label: '2025',
                                                                            },
                                                                            {
                                                                                value: '4',
                                                                                label: '2026',
                                                                            },
                                                                            {
                                                                                value: '5',
                                                                                label: '2027',
                                                                            },
                                                                            {
                                                                                value: '6',
                                                                                label: '2028',
                                                                            },
                                                                        ]}
                                                                    />
                                                            </FormGroup>
                                                        </Col>  
                                                        <Col lg={6}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Cvv</label>
                                                                <Input size="large" type="number" placeholder="Enter Cvv"/>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <FormGroup className="form-group">
                                                                <label className="ant-label">Alternative Email Address</label>
                                                                <Input size="large" type="email" placeholder="Enter Email Address"/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Link to='/' className="btn btn-primary" type="button"> Pay Now</Link>
                                                </Form>
                                            </Tab>
                                        </Tabs>
                                    </div>
                                </div>
                            </Col>    
                        </Row>                    
                    </Container>
                </div>
            </main>
        </>
    );
  }
  
  export default Payonline;